<template>
  <ontick-aero-component :active="active" @close="close">
    <div class="w-screen max-w-md">
      <div class="glass-carbon flex h-full flex-col overflow-y-scroll pb-24">
        <div
          class="dark:bg-ontick-carbon-500 sticky top-0 z-10 bg-gray-50 px-6 py-3 pr-14"
        >
          <div class="flex items-center space-x-4">
            <div class="h-7">
              <button
                @click="$emit('close')"
                class="py-1 text-gray-400 hover:text-gray-400 focus:outline-none"
              >
                <span v-html="$icons.arrow_left" />
              </button>
            </div>
            <h2
              class="text-ontick-carbon-900 py-3 text-lg font-semibold dark:text-gray-300"
            >
              Filtros
            </h2>
          </div>
        </div>

        <div class="space-y-8 px-6 py-3 pr-14">
          <div
            v-for="filter in getFilters"
            :key="filter.slug"
            class="space-y-2"
            :class="{ 'block md:hidden': filter.slug === 'chars' }"
          >
            <div class="flex items-center space-x-2">
              <span class="text-sm">
                {{ filter.name }}
              </span>
              <!-- <div
                v-if="
                  [
                    'strategy_risk',
                    'account_level',
                    'strategy_timeframe',
                    'strategy_style',
                  ].includes(filter.slug)
                "
                class="text-ontick-red-600 text-xs"
              >
                <span>(Dado não está disponível)</span>
              </div> -->
              <!-- <div
                v-if="['profit'].includes(filter.slug)"
                class="text-ontick-orange-600 text-xs"
              >
                <span>(Dúvida sobre como calcular)</span>
              </div> -->
            </div>
            <div
              class="relative w-full overflow-hidden rounded"
              v-if="filter.type === 'string'"
            >
              <input
                type="text"
                class="dark:bg-ontick-steel-500 border-ontick-steel-300 block w-full border-2 bg-transparent dark:border-none"
                v-if="active"
                :id="'input' + filter.slug"
                @input="
                  search({ slug: filter.slug, value: $event.target.value })
                "
              />
              <div
                class="dark:bg-ontick-steel-500 absolute top-0 right-0 flex h-full items-center px-2"
                v-if="fakeLoading"
              >
                <i v-html="$icons.loading" class="text-ontick-blue-600"></i>
                <span class="sr-only">Carregando busca</span>
              </div>
            </div>

            <div class="w-full">
              <ontick-slider-component
                v-if="filter.type === 'range'"
                :min="filter.min"
                :max="filter.max"
                :from="filter.from"
                :to="filter.to"
                :step="filter.step"
                :isCurrency="isCurrency(filter.slug)"
                :percent="['profit'].includes(filter.slug)"
                :limit="limit(filter.slug)"
                @input="setRangeFilter({ slug: filter.slug, value: $event })"
              />
              <div class="space-y-2" v-if="filter.type === 'tagbox'">
                <button
                  v-for="item in setItems(filter)"
                  :key="item.value"
                  class="mx-1 max-w-min cursor-pointer whitespace-nowrap rounded px-2 py-1 text-sm first:ml-0 last:mr-0"
                  :class="
                    filter.active.includes(item.value)
                      ? 'bg-ontick-blue-600'
                      : 'dark:bg-ontick-steel-500 ring-ontick-steel-300 bg-transparent ring-1 dark:ring-0'
                  "
                  @click="
                    setToggleFilter({ slug: filter.slug, value: item.value })
                  "
                >
                  {{ item.displayName }}
                </button>
              </div>
            </div>
          </div>
          <div class="pt-6" v-if="showButton">
            <ontick-button
              class="w-full"
              customClass="border border-ontick-blue-600 text-ontick-blue-600 rounded"
              @click.native="clearActiveFilters"
            >
              Remover filtros
            </ontick-button>
          </div>
        </div>
      </div>
    </div>
  </ontick-aero-component>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import { CollapseTransition } from "@ivanv/vue-collapse-transition";
import CollapseGroup from "@/app/shared/components/expanded/collapse.transition-group.component";
import OntickSliderComponent from "../../../../../shared/components/basic/ontick-slider.component.vue";
import OntickAeroComponent from "../../../../../shared/components/basic/ontick-aero.component.vue";
import EventBus from "../../../../../shared/utils/event_bus";
import OntickInputComponent from "../../../../../shared/components/basic/ontick-input.component.vue";
export default {
  components: {
    CollapseTransition,
    CollapseGroup,
    OntickSliderComponent,
    OntickAeroComponent,
    OntickInputComponent,
  },

  props: {
    active: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      searchTimeout: null,
      fakeLoading: false,
      screenSize: window.innerHeight,
    };
  },

  computed: {
    ...mapGetters({
      getFilters: "investment/getFilters",
      getSymbolsFilterOptions: "investment/getSymbolsFilterOptions",
      getDeveloperFilterOptions: "investment/getDeveloperFilterOptions",
      getSelectedAccount: "accountTypes/getSelectedAccount",
    }),
    showButton() {
      return (
        this.getFilters
          .filter((item) => item.type === "string")
          .some((item) => item.value.length) ||
        this.getFilters
          .filter((item) => item.type === "tagbox")
          .some((item) => item.active.length)
      );
    },
  },

  methods: {
    ...mapActions({
      setStringFilter: "investment/setStringFilter",
      setRangeFilter: "investment/setRangeFilter",
      setToggleFilter: "investment/setToggleFilter",
      clearActiveFilters: "investment/clearActiveFilters",
    }),
    setItems(filter) {
      if (filter.slug === "strategy_symbol") {
        return this.getSymbolsFilterOptions;
      }
      if (filter.slug === "strategy_developer") {
        return this.getDeveloperFilterOptions;
      }
      return filter.items;
    },
    search(val) {
      clearTimeout(this.searchTimeout);
      this.fakeLoading = true;
      this.searchTimeout = setTimeout(() => {
        this.setStringFilter(val);
        this.fakeLoading = false;
      }, 1000);
    },
    limit(val) {
      switch (val) {
        case "sugg_capital":
          return ">=";
        case "max_daily_loss":
          return "<=";
        case "max_daily_gain":
          return ">=";
        case "curr_volume":
          return "<=";
        case "profit":
          return ">=";
        default:
          return "=";
      }
    },
    isCurrency(val) {
      return ["sugg_capital", "max_daily_loss", "max_daily_gain"].includes(val);
    },
    close() {
      EventBus.$emit("CLOSE_INVESTMENT_FILTERS");
    },
    setWindowSize(e) {
      // console.log(e);
      this.screenSize = e.target.innerWidth;
    },
  },

  created() {
    EventBus.$on("MARKETPLACE_CLEAR_ACTIVE_FILTERS", () => {
      document.getElementById("input" + "chars").value = this.getFilters.find(
        (item) => item.slug === "chars"
      ).initialValue;
    });
  },

  mounted() {
    this.$nextTick(() => {
      window.addEventListener("resize", this.setWindowSize);
    });
  },

  beforeDestroy() {
    window.removeEventListener("resize", this.setWindowSize);
  },
};
</script>
